/**
 * AEM Boundless benefit multipliers are authored as a count plus a trailing x/X
 * (for example `17x`, `17X`, `3x`). Only that trailing letter is normalized.
 * Values like `x2` or `2.5x pts` are left unchanged.
 */
export const formatBenefitMultiplier = (multiplier: string): string => multiplier.replace(/x$/i, 'X');
